import React, { FC } from 'react';
import classnames from 'classnames';
import { Size } from './enums/size.enum';
import { Props } from './props';
import './styles.scss';

export * from './enums/size.enum';

const BASE_SIZE = 50;
const MIN = BASE_SIZE / 2; // min-x and min-y
const STROKE_WIDTH = 2; // the width of circle border
const BASE_CIRCLE_SIZE = BASE_SIZE / 2 - STROKE_WIDTH / 2;

export const CircularLoading: FC<Props> = ({ className, size, children }) => {
  return (
    <div className={classnames('fr-circular-loading', `fr-circular-loading--${size}`, className)}>
      <svg
        className={classnames('fr-circular-loading__svg', !!children && 'fr-circular-loading__svg--full')}
        viewBox={`${MIN} ${MIN} ${BASE_SIZE} ${BASE_SIZE}`}
      >
        <circle
          className="fr-circular-loading__background"
          cx={`${BASE_SIZE}`}
          cy={`${BASE_SIZE}`}
          fill="none"
          r={`${BASE_CIRCLE_SIZE}`}
          strokeWidth={`${STROKE_WIDTH}`}
        />
        <circle
          className="fr-circular-loading__path"
          cx={`${BASE_SIZE}`}
          cy={`${BASE_SIZE}`}
          fill="none"
          r={`${BASE_CIRCLE_SIZE}`}
          strokeWidth={`${STROKE_WIDTH}`}
        />
      </svg>

      {!children ? null : <div className="fr-circular-loading__children-container">{children}</div>}
    </div>
  );
};

CircularLoading.defaultProps = {
  size: Size.XX_SMALL,
};
